<pf-loading-overlay />
<div class="app">
    <lib-toastmessage />
    @if (_router.url !== '/') {
        <pf-navigationmodule
            [adminHomeUrl]="adminHomeUrl"
            [colorOfNavBar]="colorOfNavBar"
            [hasLogin]="hasLogin"
            [hasLogo]="false"
            [isAdmin]="true"
            [isShoppingCart]="false"
            [logoPosition]="positionL"
            [nameOfTheSite]="title"
        />
    }
    <router-outlet (activate)="loadRouterOutletInput($event)" />
    <div class="footer-container">
        <div class="footer-admin">
            <h1></h1>
        </div>
    </div>
</div>
